import React, { useContext, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import ContentGuard from 'src/layout/ContentGuard/ContentGuard';
import * as globalConstants from 'src/constants/index';
import { UserSessionContext } from 'src/context/UserSessionContext';
import styles from 'src/pages/Design/Design.module.scss';
import { Box, Button, Typography } from '@mui/material';

interface DesignAccessButtonProps {
  url: string;
  text: string;
}

const DesignAccessButton: React.FC<DesignAccessButtonProps> = ({
  url,
  text,
}) => {
  const { setOnDesignMockupPage } = useContext(UserSessionContext);
  const navigate = useNavigate();
  return (
    <>
      <Button
        variant='contained'
        className={styles.designPageButton}
        onClick={() => {
          navigate(url);
          setOnDesignMockupPage(true);
        }}
      >
        {text}
      </Button>
    </>
  );
};

const DesignNavigation: React.FC = () => {
  return (
    <div className={styles.designPageButtonContainer}>
      <DesignAccessButton
        url='/design/game-dashboard-glass'
        text='Game Dashboard Glass'
      />
      <DesignAccessButton
        url='/design/cat-parachute-parallax'
        text='Cat Parachute Parallax'
      />
      <DesignAccessButton
        url='/design/initial-beginner-parallax'
        text='Initial Beginner Parallax'
      />
      <DesignAccessButton
        url='/design/simple-basic-grid'
        text='Simple Basic Grid'
      />
      <DesignAccessButton
        url='/design/simple-photo-grid'
        text='Simple Photo Grid'
      />
      <DesignAccessButton
        url='/design/simple-animated-grid'
        text='Simple Animated Grid'
      />
      <DesignAccessButton
        url='/design/forest-welcome-parallax'
        text='Forest Welcome Parallax'
      />
      <DesignAccessButton
        url='/design/beginner-gsap-animation'
        text='Beginner GSAP Animation'
      />
      <DesignAccessButton
        url='/design/stay-afloat-animation'
        text='Stay Afloat Animation'
      />
    </div>
  );
};

const Design: React.FC = () => {
  const { user, setOnDesignMockupPage } = useContext(UserSessionContext);
  useEffect(() => {
    setOnDesignMockupPage(false);
  }, []);

  return (
    <Box sx={{ minHeight: '67vh', padding: '32px' }}>
      <Typography variant='h6' sx={{ display: 'flex', justifyContent: 'center'}}> Design Experiments </Typography>
      <DesignNavigation />
    </Box>
  );
};

export default Design;
